module.exports = __webpack_public_path__ + "static/media/Information.d170c356.pdf";